
export default {
    formacao: {},
    formacoes: []
}